__turbopack_context__.v({
  "animatedPreloader": "countLabel-module-scss-module__WsezRG__animatedPreloader",
  "countInTab": "countLabel-module-scss-module__WsezRG__countInTab",
  "gradient": "countLabel-module-scss-module__WsezRG__gradient",
});
